import styled, { css } from 'styled-components';
import { designTokens } from '../../../ui/foundation/DesignTokens';

const StyledButton = styled.button`
  font-family: ${designTokens.fonts.heading};
  background-color: ${(props) =>
    props.color === "primary" ? designTokens.colors.primary[500] : designTokens.colors.gray[400]};
  width: 13rem;
  height: 3rem;
  border-radius: ${designTokens.radius.sm};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  transition: all 0.2s ease;

  /* Design System V4.0 variant */
  ${(props) =>
    props.designV4 &&
    css`
      font-family: ${designTokens.fonts.heading};
      background-color: ${designTokens.colors.primary[500]};
      width: auto;
      padding: 10px 24px;
      height: auto;
      border-radius: ${designTokens.radius.full};
      font-weight: 600;
      font-size: 0.9rem;
      box-shadow: ${designTokens.shadows.md};
      transition: all 0.2s ease;
      gap: 8px;

      &:hover {
        background-color: ${designTokens.colors.primary[600]};
        transform: translateY(-1px);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
      }
    `}

  & > span {
    font-family: ${designTokens.fonts.heading};
  }

  ${(props) =>
    props.full &&
    css`
      width: 100%;
    `}
  ${(props) =>
    props.isloadingForm &&
    css`
      display: none;
    `}

  ${(props) =>
    props.right &&
    css`
      margin: 0 0 0 auto;
    `}
  &:hover {
    cursor: pointer;
  }

  ${(props) =>
    props.small &&
    css`
      width: 2rem;
      height: 2rem;
    `}

  ${(props) =>
    props.xs &&
    css`
      width: 1.5rem;
      height: 1.5rem;
    `}

  ${(props) =>
    props.warning &&
    css`
      background-color: ${designTokens.colors.error[500]};
    `}

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.6;
    `}


  ${(props) =>
    props.facebook &&
    css`
      background-color: #0866FF;
      color: white;
      font-size: 1.1rem;
      width: 18rem;
      padding: 12px 0;
      justify-content: center;
      align-items: center;
      gap: 12px;
    `}

  ${(props) =>
    props.whatsapp &&
    css`
      justify-content: space-between;
      background-color: #25d366;
      font-size: 0.875rem;
      width: 16.375rem;
      padding: 0 1.5rem;
    `}
  
  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
  
  ${(props) =>
    props.secondary &&
    css`
      background-color: white;
      color: ${designTokens.colors.primary[500]};
      border: 1px solid ${designTokens.colors.primary[500]};
    `}

  ${(props) =>
    props.tight &&
    css`
      height: 1.8rem;
      width: auto;
      padding: 0.1rem 0.8rem;
    `}

  ${(props) =>
    props.addElementButton &&
    css`
      padding: 12px 16px;
      font-size: 0.75rem;
      width: 9.75rem;
      height: 2.75rem;
      font-family: ${designTokens.fonts.heading};
      border-radius: ${designTokens.radius.md};
    `}
  ${(props) =>
    props.ExportButton &&
    css`
      padding: 12px 16px;
      font-size: 12px;
      width: 8.75rem;
      height: 2.75rem;
      font-family: ${designTokens.fonts.heading};
      border-radius: ${designTokens.radius.md};
    `}
  ${(props) =>
    props.importButton &&
    css`
      width: 9.75rem;
      height: 2.75rem;
      color: ${designTokens.colors.primary[500]};
      padding: 12px 16px;
      background-color: white;
      border-radius: ${designTokens.radius.md};
      border: 2px solid ${designTokens.colors.primary[500]};
    `}
  ${(props) =>
    props.importCancelButton &&
    css`
      width: 13.5rem;
      height: 2.75rem;
      margin-right: 8.625rem;
      color: ${designTokens.colors.error[500]};
      padding: 12px 16px;
      background-color: white;
      border: 2px solid ${designTokens.colors.error[500]};
      border-radius: ${designTokens.radius.sm};
    `}
  ${(props) =>
    props.importInfoCancelButton &&
    css`
      width: 13.5rem;
      height: 2.75rem;
      margin-left: 33px;
      margin-right: 3.625rem;
      color: ${designTokens.colors.error[500]};
      padding: 12px 16px;
      background-color: white;
      border: 2px solid ${designTokens.colors.error[500]};
      border-radius: ${designTokens.radius.sm};
    `}
  ${(props) =>
    props.importCancelButtonChannels &&
    css`
      width: 13.5rem;
      height: 2.75rem;
      margin-right: 3.625rem;
      color: ${designTokens.colors.error[500]};
      margin-left: 2.063rem;
      padding: 12px 16px;
      background-color: white;
      border: 2px solid ${designTokens.colors.error[500]};
      border-radius: ${designTokens.radius.sm};
    `}
  ${(props) =>
    props.importConfirmButton &&
    css`
      width: 13.5rem;
      height: 2.75rem;
      margin-right: 2.063rem;
      color: white;
      padding: 12px 16px;
      background: ${designTokens.colors.primary[500]};
      border-radius: ${designTokens.radius.sm};
    `}
  ${(props) =>
    props.followUpCancelModal &&
    css`
      width: 372px;
      height: 44px;
      left: 42px;

      border: 1.6px solid ${designTokens.colors.error[500]};
      border-radius: ${designTokens.radius.sm};
      background-color: #fff;

      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      color: ${designTokens.colors.error[500]};
      line-height: 1rem;

      letter-spacing: 0.275122px;
    `}
  ${(props) =>
    props.followUpConfirmModal &&
    css`
      width: 372px;
      height: 44px;
      left: 42px;

      border-radius: ${designTokens.radius.sm};
      background-color: ${designTokens.colors.success[500]};

      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-weight: 700;
      font-size: 1rem;
      color: #fff;
      line-height: 16px;

      letter-spacing: 0.275122px;
    `}
  ${(props) =>
    props.templateSelect &&
    css`
      width: 100%;
      height: 40px;
      background: ${designTokens.colors.primary[500]};
      border-radius: ${designTokens.radius.md};
      font-family: ${designTokens.fonts.body};
      font-style: normal;
      font-weight: 600;
      font-size: 0.875rem;
      line-height: 1.5;
      letter-spacing: -0.01em;
      color: #ffffff;
      gap: 8px;
      transition: all 0.15s ease;
      box-shadow: ${designTokens.shadows.sm};

      &:hover {
        background: ${designTokens.colors.primary[600]};
        transform: translateY(-1px);
        box-shadow: ${designTokens.shadows.md};
      }

      &:disabled {
        background: ${designTokens.colors.gray[400]};
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
      }
    `}
  ${(props) =>
    props.createTemplate &&
    css`
      min-height: 42px;
      padding: 10px 24px;
      white-space: nowrap;

      background-color: ${(props) => (props.disabled ? designTokens.colors.gray[300] : designTokens.colors.primary[500])};
      border-radius: ${designTokens.radius.full};
      box-shadow: 0 4px 12px rgba(39, 177, 179, 0.3);

      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-weight: 600;
      font-size: ${designTokens.fontSizes.sm};
      line-height: 1;

      letter-spacing: -0.01em;

      color: #ffffff;
      transition: all 0.15s ease;

      &:hover:not(:disabled) {
        background-color: ${designTokens.colors.primary[600]};
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(39, 177, 179, 0.4);
      }

      &:active:not(:disabled) {
        transform: translateY(0);
      }

      @media (max-width: 768px) {
        flex: 1;
        justify-content: center;
      }
    `}
  ${(props) =>
    props.broadcastType &&
    css`
      width: 16rem;
      height: 2.375rem;

      margin-top: 1.813rem;

      background-color: ${(props) => (props.disabled ? designTokens.colors.gray[300] : designTokens.colors.primary[500])};
      border-radius: ${designTokens.radius.sm};

      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-weight: 700;
      font-size: 1rem;
      line-height: 150%;

      letter-spacing: -0.257238px;

      color: #ffffff;
    `}
  ${(props) =>
    props.createTemplateDisable &&
    css`
      width: 10.5rem;
      height: 2.375rem;
      left: 54px;
      top: 175px;

      background: ${designTokens.colors.gray[300]};
      border-radius: ${designTokens.radius.sm};

      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-weight: 700;
      font-size: 1rem;
      line-height: 150%;

      letter-spacing: -0.257238px;

      color: #ffffff;
    `}
  ${(props) =>
    props.createTemplateCard &&
    css`
      width: 19rem;
      height: 2.375rem;
      left: 54px;
      top: 175px;

      background: ${designTokens.colors.primary[500]};
      border-radius: ${designTokens.radius.sm};

      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-size: 1rem;
      line-height: 150%;

      letter-spacing: -0.257238px;

      color: #ffffff;
    `}
  ${(props) =>
    props.broadcastQualityModal &&
    css`
      margin-top: 4.625rem;
      width: 25.063rem;
      height: 2.375rem;
      left: 54px;
      top: 175px;

      background: ${designTokens.colors.primary[500]};
      border-radius: ${designTokens.radius.sm};

      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-size: 1rem;
      line-height: 150%;

      letter-spacing: -0.257238px;

      color: #ffffff;
    `}
  ${(props) =>
    props.disabledBroadcast &&
    css`
      width: 16rem;
      height: 2.375rem;

      margin-top: 1.813rem;

      background: ${designTokens.colors.gray[300]};
      border-radius: ${designTokens.radius.sm};

      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-weight: 700;
      font-size: 1rem;
      line-height: 150%;

      letter-spacing: -0.257238px;

      color: #ffffff;
    `}
      ${(props) =>
    props.broadcastAnalitycs &&
    css`
      width: 10.5rem;
      height: 2.375rem;
      left: 54px;
      top: 175px;

      background-color: ${(props) => (props.disabled ? designTokens.colors.gray[300] : designTokens.colors.primary[500])};
      border-radius: ${designTokens.radius.sm};

      font-family: ${designTokens.fonts.heading};
      font-style: normal;
      font-weight: 700;
      font-size: 1rem;
      line-height: 150%;

      letter-spacing: -0.257238px;

      color: #ffffff;
    `}
`;

export default StyledButton;



